// extracted by mini-css-extract-plugin
module.exports = {"item":"User_item__osNnv"};